import { render } from "./NewLinks.vue?vue&type=template&id=861de4e8"
import script from "./NewLinks.vue?vue&type=script&lang=js"
export * from "./NewLinks.vue?vue&type=script&lang=js"

import "./NewLinks.vue?vue&type=style&index=0&id=861de4e8&lang=css"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__